const demo = {
  // common translations

  PageTitle: "Select an example dataset",
  Difficulty: "Difficulty",
  DatasetInformation: "Dataset Information",
  NumDatapoints: "Number of Sensor Readings/ Data Points",
  NumFeatures: "Number of Features",
  TargetDescription: "Target(s)",
  Step1: "1. Preprocessing of the Dataset",
  Step2:
    "2. Training of a Regression Model with automatic hyperparameter\n tuning",
  Step3:
    "3. Training of an Error Model, predicting the uncertainty of the trained Regression Model",
  Step4: "4. Plot Generation for Model Evaluation",
  Step5: "5. Provision of a downloadable and executable model",
  ButtonImportExample: "Import Example-Dataset and view",

  // examples in detail
  examples: {
    dataset1: {
      // Example 1
      Title: "Predicting Milk Quality",
      DatasetFileName: "🐄 Milch Qualität",
      TeaserImageUrl:
        "https://images.pexels.com/photos/3214973/pexels-photo-3214973.jpeg",
      Description:
        "\nExample dataset for a ML application in a dairy. Based on measurement data of individual milk samples, the quality class of the milk is to be determined with the help of ML models.",
      DifficultyRating: 1,
      NumDatapoints: 200,
      Features: "6 (e.g. pH value, temperature, colour, ...)",
      Targets: "Milk quality class: 0, 1, 2",
    },
    dataset2: {
      // Example 2
      Title: "Determination of cement strength",
      DatasetFileName: "🏗️ Beton Druckfestigkeit",
      TeaserImageUrl:
        "https://images.pexels.com/photos/2628393/pexels-photo-2628393.jpeg?auto=compress&cs=tinysrgb&w=1600",
      Description:
        "\nExample data set for a ML application from cement production. The compressive strength of the concrete is to be determined on the basis of the mix components. In addition, feature importation is to provide new insight into which input data have the greatest influence on the compressive strength.",
      DifficultyRating: 2,
      NumDatapoints: 5407,
      NumFeatures: 8,
      Features: "8 (z.B. Blast Furnace Slag, Fly Ash, Superplasticizer, ...)",
      Targets: "Compressive strength in MPa",
    },
    dataset3: {
      // Example 3
      Title:
        "Day-ahead forecast of a roof-mounted photovoltaic system production",
      DatasetFileName: "☀️ Photovoltaik",
      TeaserImageUrl:
        "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      Description:
        "\nExample data set of a ML application for a photovoltaic roof system. With the help of a ML model, the production of the coming 24h is to be predicted based on weather forecast data.",
      Targets: "24h total production in Watt hours",
      DifficultyRating: 4,
      NumDatapoints: 1977,
      Features: "9 (e.g. Defuse radiation, Direct radiation, ...)",
    },
    dataset4: {
      // Example 4
      Title:
        "Day-ahead forecast of a roof-mounted photovoltaic system production ⚠️ with unsuitable data",
      DatasetFileName: "☀️ Photovoltaik (ungeeignet)",
      TeaserImageUrl:
        "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      Description:
        "\nExample data set of a ML application for a photovoltaic roof system. With the help of a ML model, the production of the coming 24h is to be predicted based on weather forecast data. \n ⚠️ There are two versions of this dataset, this is the version with unsuitable data",
      Targets: "24h total production in Watt hours",
      DifficultyRating: 4,
      NumDatapoints: 1518,
      Features: "9 (e.g. Defuse radiation, Direct radiation, ...)",
    },
  },
};

export default demo;
